
import MediaItem from './media-item';
import _get from 'lodash/get';

const selectedPredicate = (item) => item.selected;

/**
 *
 * @desc Playlist
 *
 */
class Playlist {

    constructor(items = [], selected, mediaConfig) {

        this.mediaConfig = mediaConfig;
        this.items = items;
        this.setSelectedItem(selected || _get(this, 'items.0.contentId'));

    }

    set items(items) {

        this._items = items.map((item) => new MediaItem(item, this.mediaConfig));

    }

    get items() {

        return this._items;

    }

    setSelectedItem(contentId = '') {

        this.items
            .forEach((item) => {

                item.selected = false;

            });

        this.items
            .filter((item) => item.contentId === contentId)
            .forEach((item) => {

                item.selected = true;

            });

    }

    /**
     *
     * Returns selected item
     * @returns {object}
     *
     */
    getSelectedItem() {

        return this.items.find(selectedPredicate);

    }

    /**
     *
     * Returns selected item
     * @returns {number}
     *
     */
    getSelectedItemIndex() {

        return this.items.findIndex(selectedPredicate);

    }

    /**
     *
     * Returns the next item to be played
     * @returns {object}
     *
     */
    getNextItem() {

        return this.items[this.getSelectedItemIndex() + 1] || this.items[0];

    }

}

export default Playlist;
